<template>
  <app-common-layout>
    <template #header>
    </template>
    <div class="">
      <div class="mx-auto max-w-5xl bg-white m-4 p-8 sm:px-6 lg:px-8">
        <div class="sm:grid sm:grid-cols-3">
          <div class="col-span-1">
            <h2 class="text-lg sm:text-right">現在のメールアドレス</h2>
          </div>
          <div class="col-span-2 mt-4 sm:mt-0 ml-4 sm:ml-16">
            <p>{{ auth.currentUser ? auth.currentUser.email : '' }}</p>
          </div>
        </div>
        <form
          class="sm:grid sm:grid-cols-3 mt-10"
          @submit.prevent="updateUserEmail">
          <div class="col-span-1">
            <h2 class="text-lg sm:text-right">メールアドレスの変更</h2>
          </div>
          <div class="col-span-2 mt-4 sm:mt-0 ml-4 sm:ml-16">
            <template v-if="messages.newEmail.errors">
              <p
                v-for="(error, index) in messages.newEmail.errors"
                :key="index"
                class="text-red-500 text-sm">
                {{ error }}
              </p>
            </template>
            <jet-label
              for="email"
              value="新しいメールアドレス" />
            <jet-input
              id="email"
              v-model="newEmail.email"
              type="text"
              class="mt-1 w-72 sm:w-96"
              required
              autofocus />
            <jet-label
              for="password"
              class="mt-4"
              value="ログインパスワード" />
            <jet-input
              id="password"
              v-model="newEmail.password"
              type="password"
              class="mt-1 w-72 sm:w-96 block"
              autocomplete="off" />
            <button
              :disabled="isProcessing"
              class="bg-white text-CLIENT_PRIMARY_PINK text-center border-2 border-CLIENT_PRIMARY_PINK text-base rounded-xl px-2 py-2 mt-4 hover:bg-gray-100 duration-500 disabled:cursor-not-allowed">
              メールアドレス変更
            </button>
          </div>
        </form>
        <form
          class="sm:grid sm:grid-cols-3 mt-10"
          @submit.prevent="sendIsEmailReceiving">
          <div class="col-span-1">
            <h2 class="text-lg sm:text-right">お知らせメール受信設定</h2>
          </div>
          <div class="col-span-2 mt-4 sm:mt-0 ml-4 sm:ml-16">
            <div class="flex w-96 items-center">
              <input
                id="email_receiving"
                v-model="isEmailReceiving"
                type="checkbox"
                class="w-4 mr-3 rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                autofocus />
              <p class="block font-medium text-sm text-gray-700">
                お知らせメールを受信する
              </p>
            </div>

            <button
              :disabled="isProcessing"
              class="bg-white text-CLIENT_PRIMARY_PINK text-center border-2 border-CLIENT_PRIMARY_PINK text-base rounded-xl px-2 py-2 mt-4 hover:bg-gray-100 duration-500 disabled:cursor-not-allowed">
              受信設定を変更する
            </button>
          </div>
        </form>
        <form
          class="sm:grid sm:grid-cols-3 mt-10"
          @submit.prevent="updateUserPassword">
          <div class="col-span-1">
            <h2 class="text-lg sm:text-right">パスワードの再設定</h2>
          </div>
          <div class="col-span-2 mt-4 sm:mt-0 ml-4 sm:ml-16">
            <button
              :disabled="isProcessing"
              class="block bg-white text-CLIENT_PRIMARY_PINK text-center border-2 border-CLIENT_PRIMARY_PINK text-base rounded-xl px-2 py-2 mt-4 sm:mt-0 hover:bg-gray-100 duration-500 disabled:cursor-not-allowed">
              パスワード再設定メール送信
            </button>
            <p class="inline-block text-sm text-red-400">*メール送信後、自動的にログアウトされます。</p>
          </div>
        </form>
        <form
          class="sm:grid sm:grid-cols-3 mt-10"
          @submit.prevent="sendVerificationEmail">
          <div class="col-span-1">
            <h2 class="text-lg sm:text-right">認証用メール再送信</h2>
          </div>
          <div class="col-span-2 mt-4 sm:mt-0 ml-4 sm:ml-16">
            <button
              :disabled="isProcessing"
              class="bg-white text-CLIENT_PRIMARY_PINK text-center border-2 border-CLIENT_PRIMARY_PINK text-base rounded-xl px-2 py-2 hover:bg-gray-100 duration-500 disabled:cursor-not-allowed">
              再送信
            </button>
          </div>
        </form>
        <form
          class="sm:grid sm:grid-cols-3 mt-10"
          @submit.prevent="deleteAccount">
          <div class="col-span-1">
            <h2 class="text-lg sm:text-right">アカウント削除</h2>
          </div>
          <div class="col-span-2 mt-4 sm:mt-0 ml-4 sm:ml-16">
            <jet-label
              for="password"
              class="mt-4 sm:mt-0"
              value="ログインパスワード" />
            <template v-if="messages.deleteInfo.errors">
              <p
                v-for="(error, index) in messages.deleteInfo.errors"
                :key="index"
                class="text-red-400 text-sm">
                {{ error }}
              </p>
            </template>
            <jet-input
              id="delete-password"
              v-model="deleteInfo.password"
              type="password"
              class="mt-1 mr-4 w-40"
              autocomplete="off" />
            <button
              class="bg-white text-CLIENT_PRIMARY_PINK text-center border-2 border-CLIENT_PRIMARY_PINK text-base rounded-xl px-2 py-2 mt-4 sm:ml-12 sm:mt-0 hover:bg-gray-100 duration-500">
              削除
            </button>
          </div>
        </form>
        <SchoolCodeInputForm
          :school-name="schoolName" />
      </div>
    </div>
  </app-common-layout>
</template>

<script setup>
import {
  getAuth,
  reauthenticateWithCredential,
  sendPasswordResetEmail,
  sendEmailVerification,
  updateEmail,
  EmailAuthProvider,
  deleteUser,
} from 'firebase/auth'
import { computed, reactive, ref } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import Swal from 'sweetalert2'
import { usePage } from '@inertiajs/inertia-vue3'
import { EmailRegex } from '@/Constants/regularExpression'
import AppCommonLayout from '@/Layouts/AppCommonLayout'
import SchoolCodeInputForm from './Partials/SchoolCodeInputForm'
import JetButton from '@/Jetstream/Button'
import JetInput from '@/Jetstream/Input'
import JetLabel from '@/Jetstream/Label'
import firebaseApp from '@/Constants/configFirebase'
import 'firebase/compat/auth'

const auth = getAuth(firebaseApp)

const props = defineProps({
  currentClientIsEmailReceiving: {
    type: Object,
    default: () => false,
    require: true,
  },
  isStripeSubscription: {
    type: Boolean,
    default: () => false,
  },
  subscriptionStatus: {
    type: Number,
    default: () => 0,
  },
  schoolName: {
    type: String,
    default: () => '',
  },
})

const isProcessing = ref(false)

// パスワードリセット後のリダイレクト先
const actionCodeSettings = {
  url: route('index'),
}

const messages = reactive({
  newEmail: {
    errors: [],
  },
  deleteInfo: {
    errors: [],
  },
})

const newEmail = reactive({
  email: '',
  password: '',
  isError: false,
})

const deleteInfo = reactive({
  password: '',
  isError: false,
})

const isEmailReceiving = ref(props.currentClientIsEmailReceiving.is_email_receiving)

const updateUserEmail = async () => {
  messages.newEmail.errors = []
  newEmail.isError = false
  isProcessing.value = true

  if (!newEmail.email.match(EmailRegex)) {
    messages.newEmail.errors.push('新しいメールアドレスを正しく入力してください。')
    newEmail.isError = true
  }
  if (auth.currentUser.email === newEmail.email) {
    messages.newEmail.errors.push('登録済みのメールアドレスです。')
    newEmail.isError = true
  }
  if (!newEmail.password) {
    messages.newEmail.errors.push('パスワードを正しく入力してください。')
    newEmail.isError = true
  }
  if (newEmail.isError) {
    isProcessing.value = false
    return false
  }

  // 認証の資格情報の取得
  const credential = await EmailAuthProvider.credential(auth.currentUser.email, newEmail.password)

  try {
    // 再認証が必要なため、再認証を行う
    await reauthenticateWithCredential(auth.currentUser, credential)
  } catch (e) {
    // パスワード不一致
    if (e.code === 'auth/wrong-password') {
      messages.newEmail.errors.push('ログインパスワードが間違っています。')
    }
    if (e.code === 'auth/too-many-requests') {
      messages.newEmail.errors.push('ログインパスワードの不一致が複数回確認されました。しばらく経ってからお試しください。')
    }
    isProcessing.value = false
    return false
  }

  Swal.fire({
    icon: 'question',
    html: `以下のメールアドレスに変更しますか？<br>${newEmail.email}`,
    showCancelButton: true,
    confirmButtonText: 'はい',
    cancelButtonText: 'いいえ',
  }).then(async (result) => {
    if (result.isConfirmed) {
      // emailの再設定
      await updateEmail(auth.currentUser, newEmail.email).then(() => {
        Swal.fire({
          icon: 'success',
          html: 'メールアドレスを再設定しました。<br>認証用メールが送信されましたのでご確認いただき再度認証してください。<br>一度ログアウトします。',
          confirmButtonText: 'はい',
        }).then(async (result) => {
          Inertia.visit(route('clients.logout.post'), {
            method: 'post',
            data: {
              is_redirect_with_flashMessage: 'メールアドレスを再設定しました。',
            },
          })
          isProcessing.value = false
        })
      }).catch((e) => {
        Swal.fire({
          text: e.code,
          icon: 'error',
          confirmButtonText: '閉じる',
        })
        isProcessing.value = false
        return false
      })
    }
  })
  return undefined
}

const updateUserPassword = () => {
  Swal.fire({
    icon: 'question',
    html: 'パスワードリセットメールを送信しますか？',
    showCancelButton: true,
    confirmButtonText: 'はい',
    cancelButtonText: 'いいえ',
  }).then(async (result) => {
    if (result.isConfirmed) {
      isProcessing.value = true
      sendPasswordResetEmail(auth, auth.currentUser.email, actionCodeSettings).then(() => {
        Swal.fire({
          icon: 'success',
          text: 'パスワードリセットメールを送信しました。一度ログアウトします。',
          confirmButtonText: 'はい',
        }).then(async (result) => {
          Inertia.visit(route('clients.logout.post'), {
            method: 'post',
            data: {
              is_redirect_with_flashMessage: 'パスワードリセットメールを送信しました。',
            },
          })
          isProcessing.value = false
        })
      }).catch((e) => {
        Swal.fire({
          text: e.code,
          icon: 'error',
          confirmButtonText: '閉じる',
        })
        isProcessing.value = false
      })
    }
  })
}

const sendIsEmailReceiving = () => {
  isProcessing.value = true
  Inertia.post(route('client.mypage.update'), {
    is_email_receiving: isEmailReceiving.value === true ? 1 : 0,
  })
  isProcessing.value = false
}

const sendVerificationEmail = async () => {
  Swal.fire({
    icon: 'question',
    html: 'パスワードリセットメールを送信しますか？',
    showCancelButton: true,
    confirmButtonText: 'はい',
    cancelButtonText: 'いいえ',
  }).then(async (result) => {
    if (result.isConfirmed) {
      isProcessing.value = true
      await sendEmailVerification(auth.currentUser, actionCodeSettings).then(() => {
        Inertia.post(route('client.mypage.redirect'))
        isProcessing.value = false
      }).catch((e) => {
        // eslint-disable-next-line no-alert
        if (e.code === 'auth/too-many-requests') {
          alert('しばらく経ってから再度お試しください。')
        } else {
          alert(e.code)
        }
        isProcessing.value = false
      })
    }
    isProcessing.value = false
  })
}

const deleteAccount = async () => {
  if (props.subscriptionStatus == 1) {
    Swal.fire({
      icon: 'error',
      html: 'オンライン予備校(寺子屋)サブスクリプション購読中です。<br>削除前にトップページの購読内容確認ボタンよりサブスクリプションをご解約ください。<br>※本アカウントが残っていても課金は発生しません。',
      text: '模試の購入情報、チケット残り枚数、解答状況など全てのデータが削除されます。また、オンライン予備校(寺子屋)のサブスクリプションをしている場合は削除前に購読内容確認ページより別途ご解約ください。',
      confirmButtonText: '閉じる',
    })
    return
  }
  messages.deleteInfo.errors = []
  deleteInfo.isError = false
  isProcessing.value = true

  if (!deleteInfo.password) {
    messages.deleteInfo.errors.push('パスワードを正しく入力してください。')
    deleteInfo.isError = true
  }
  if (deleteInfo.isError) {
    isProcessing.value = false
    return false
  }

  // 認証の資格情報の取得
  const credential = EmailAuthProvider.credential(auth.currentUser.email, deleteInfo.password)

  try {
    // 再認証が必要なため、再認証を行う
    await reauthenticateWithCredential(auth.currentUser, credential)
  } catch (e) {
    // パスワード不一致
    if (e.code === 'auth/wrong-password') {
      messages.deleteInfo.errors.push('ログインパスワードが間違っています。')
    }
    if (e.code === 'auth/too-many-requests') {
      messages.deleteInfo.errors.push('ログインパスワードの不一致が複数回確認されました。しばらく経ってからお試しください。')
    }
    return false
  }

  // emailの再設定
  Swal.fire({
    icon: 'error',
    title: '本当にアカウントを削除してもよろしいですか？',
    text: '模試の購入情報、チケット残り枚数、解答状況など全てのデータが削除されます。',
    showCancelButton: true,
    confirmButtonText: 'はい',
    cancelButtonText: 'いいえ',
  }).then(async (result) => {
    if (result.isConfirmed) {
      await deleteUser(auth.currentUser).then(() => {
        Inertia.delete(route('clients.delete'), {
          data: {
            firebase_deleted_by_browser: true,
          },
        })
        isProcessing.value = false
      }).catch((e) => {
        // eslint-disable-next-line no-alert
        alert(e.code)
        isProcessing.value = false
      })
    }
  })
}
</script>
